// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"BannerC_TheComp__j0Tum"};